import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HandleError } from '../../../../components/common/utils/handleError.component';
import { PolizaEntity } from '../../entities/polizas_cliente_entity';
import { PlanVamEntity, Detalles, BeneficiosPlan } from '../../../vam/vam_entity';
import { CondicionesVamServices } from './condiciones.service';

const swal = require("sweetalert2");

@Component({
    selector: 'condicionesEmpresa',
    templateUrl: 'condiciones.template.html'
})

export class CondicionesVamComponent implements OnChanges {
    @Input() polizaContratada: PolizaEntity;
    nombresPlanes: string[];
    condicionesPlanes: PlanVamEntity[];
    showLoader: string;
    carencias: boolean;
    coberturas: boolean;
    condicionesDiferenciales: boolean;
    condicionesEspeciales: boolean;
    condicionesEspecialesDependientes: boolean;
    condicionesEspecialesTitular: boolean;
    deducibles: boolean;
    maternidades: boolean;

    constructor(private route: ActivatedRoute, private router: Router, private handleError: HandleError, public condicionesService: CondicionesVamServices) { }

    ngOnChanges() {
        this.carencias = false;
        this.coberturas = true;
        this.condicionesDiferenciales = false;
        this.condicionesEspeciales = false;
        this.condicionesEspecialesDependientes = false;
        this.condicionesEspecialesTitular = false;
        this.deducibles = false;
        this.maternidades = false;

        this.condicionesPlanes = new Array<PlanVamEntity>();
        this.showLoader = "sk-loading";
        this.nombresPlanes = new Array<string>();
        this.condicionesService.consultaPlanesDetalleVam(this.polizaContratada).subscribe(
            result => {
                this.condicionesPlanes = result;
                this.showLoader = "";
            },
            error => {
                this.handleError.redirectUrl(error);
                this.showLoader = "";
            }
        );
    }

    getCSSClasses(flag: number, lugar: string, condicion: BeneficiosPlan) {
        let bandera = false;
        bandera = this.comprobar(lugar,condicion);
        let cssClasses;
        if (bandera) {
            cssClasses = {
                'in': true,
                'active': true
            }
        } else {
            cssClasses = {
                'in': false,
                'active': false
            }
        }
        return cssClasses;
    }
    getCSSClassesHeader(flag: number, lugar: string, condicion: BeneficiosPlan) {
        let bandera = false;
        bandera = this.comprobar(lugar,condicion);
        let cssClasses;
        if (bandera) {
            cssClasses = {
                'active': true
            }
        } else {
            cssClasses = {
                'active': false,
            }
        }
        return cssClasses;
    }

    comprobar(lugar: string, condicion: BeneficiosPlan) {
        let bandera = false;
        switch (lugar) {
            case "cob":
                if (condicion.Coberturas.length > 0) {
                    bandera = true;
                }
                break;
            case "car":
                if (condicion.Coberturas.length == 0) {
                    if (condicion.Carencias.length > 0) {
                        bandera = true;
                    }
                }
                break;
            case "condDif":
                if (condicion.Coberturas.length == 0) {
                    if (condicion.Carencias.length == 0) {
                        if (condicion.CondicionesDiferenciales.length > 0) {
                            bandera = true;
                        }
                    }
                }
                break;
            case "condEsp":
                if (condicion.Coberturas.length == 0) {
                    if (condicion.Carencias.length == 0) {
                        if (condicion.CondicionesDiferenciales.length == 0) {
                            if (condicion.CondicionesEspeciales.length > 0) {
                                bandera = true;
                            }
                        }
                    }
                }
                break;
            case "condEspDep":
                if (condicion.Coberturas.length == 0) {
                    if (condicion.Carencias.length == 0) {
                        if (condicion.CondicionesDiferenciales.length == 0) {
                            if (condicion.CondicionesEspeciales.length == 0) {
                                if (condicion.CondicionesEspecialesDependiente.length > 0) {
                                    bandera = true;
                                }
                            }
                        }
                    }
                }
                break;
            case "condEspTit":
                if (condicion.Coberturas.length == 0) {
                    if (condicion.Carencias.length == 0) {
                        if (condicion.CondicionesDiferenciales.length == 0) {
                            if (condicion.CondicionesEspeciales.length == 0) {
                                if (condicion.CondicionesEspecialesDependiente.length == 0) {
                                    if (condicion.CondicionesEspecialesTitular.length > 0) {
                                        bandera = true;
                                    }
                                }
                            }
                        }
                    }
                }
                break;
            case "condDed":
                if (condicion.Coberturas.length == 0) {
                    if (condicion.Carencias.length == 0) {
                        if (condicion.CondicionesDiferenciales.length == 0) {
                            if (condicion.CondicionesEspeciales.length == 0) {
                                if (condicion.CondicionesEspecialesDependiente.length == 0) {
                                    if (condicion.CondicionesEspecialesTitular.length == 0) {
                                        if (condicion.Deducibles.length > 0) {
                                            bandera = true;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                break;
            case "condMater":
                if (condicion.Coberturas.length == 0) {
                    if (condicion.Carencias.length == 0) {
                        if (condicion.CondicionesDiferenciales.length == 0) {
                            if (condicion.CondicionesEspeciales.length == 0) {
                                if (condicion.CondicionesEspecialesDependiente.length == 0) {
                                    if (condicion.CondicionesEspecialesTitular.length == 0) {
                                        if (condicion.Deducibles.length == 0) {
                                            if (condicion.Maternidades.length > 0) {
                                                bandera = true;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                break;
        }
        return bandera;
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/vamEmpresa/condiciones/condiciones.component.ts